import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/chevron-right.svg'


const _withScopeId = n => (_pushScopeId("data-v-67920737"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "puzzle" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "description text-lg" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "description text-lg" }
const _hoisted_6 = { class: "description text-lg" }
const _hoisted_7 = { class: "d-none d-md-flex drag-and-drop" }
const _hoisted_8 = { class: "d-flex d-md-none dropdowns" }
const _hoisted_9 = { class: "buttons" }
const _hoisted_10 = { class: "main-buttons order-last order-md-first" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "text-md" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-takeda",
  src: _imports_0,
  alt: "logo-takeda"
}, null, -1))
const _hoisted_15 = { class: "d-none d-md-flex text-xs ref" }

import PageContainer from '@/components/PageContainer.vue'
import ScreenPath from '@/components/ScreenPath.vue'
import ReferencesModal from '@/components/ReferencesModal.vue'
import { puzzleReferences } from '@/data/puzzle'
import { computed, ref, watch } from 'vue'
import PuzzleDragAndDrop from '@/components/Puzzle/PuzzleDragAndDrop.vue'
import { PuzzleUserAnswer } from '@/types/Puzzle'
import { useStorePuzzle } from '@/stores/puzzle'
import { puzzle } from '@/data/puzzle'
import PuzzleModalVideoPlayer from '@/components/Puzzle/PuzzleModalVideoPlayer.vue'
import PuzzleDropdowns from '@/components/Puzzle/PuzzleDropdowns.vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const puzzleStore = useStorePuzzle()

const router = useRouter()

const referencesModal = ref<InstanceType<typeof ReferencesModal> | null>(null)

const puzzleModalVideoPlayer = ref<InstanceType<typeof ReferencesModal> | null>(
  null
)

const currentUserAnswers = ref<PuzzleUserAnswer[]>([])

watch(
  () => puzzleStore.currentVideoId,
  (currentVideoId) => {
    if (currentVideoId != null) {
      puzzleModalVideoPlayer.value?.show()
    }
  }
)

const disabledBtn = computed(
  () =>
    currentUserAnswers.value.length < puzzle.length &&
    !puzzleStore.showJustification
)

const justificationType = computed(() =>
  puzzleStore.isUserAnswersCorrect === false ? 'wrong' : 'correct'
)

function onTryAgain() {
  puzzleStore.reset()

  router.go(0)
}

function goToHome() {
  router.replace('/modules-choice')
}

function showReferences() {
  referencesModal.value?.show()
}

function onSubmitClick(dataFullVideoId: string) {
  if (!puzzleStore.showJustification) {
    puzzleStore.saveUserAnswers(currentUserAnswers.value)
  } else {
    puzzleStore.setCurrentVideoId(dataFullVideoId)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContainer, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ScreenPath, { "module-name": "MOD Video Puzzle" }),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('puzzle.title')), 1),
        (!_unref(puzzleStore).showJustification)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('puzzle.description')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t(`puzzle.justification.${_unref(justificationType)}.title`)), 1)
              ]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`puzzle.justification.${_unref(justificationType)}.description`)), 1)
            ])),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(PuzzleDragAndDrop, {
            currentUserAnswers: 
            _unref(puzzleStore).showJustification
              ? _unref(puzzleStore).userAnswers
              : currentUserAnswers.value
          
          }, null, 8, ["currentUserAnswers"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(PuzzleDropdowns, {
            currentUserAnswers: 
            _unref(puzzleStore).showJustification
              ? _unref(puzzleStore).userAnswers
              : currentUserAnswers.value
          
          }, null, 8, ["currentUserAnswers"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              disabled: _unref(disabledBtn),
              class: "btn btn-md btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onSubmitClick(_ctx.$t('puzzle.dataFullVideoId'))))
            }, _toDisplayString(_unref(puzzleStore).showJustification
                ? _ctx.$t('puzzle.watchTheVideo')
                : _ctx.$t('puzzle.confirmMyChoices')), 9, _hoisted_11),
            (_unref(puzzleStore).isUserAnswersCorrect === false)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: onTryAgain,
                  class: "btn btn-md btn-secondary"
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.tryAgain')), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(puzzleStore).showJustification)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: goToHome,
                  class: "btn btn-md btn-secondary"
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.returnHomeScreen')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "btn btn-empty btn-references order-first order-md-last",
            onClick: showReferences,
            disabled: !_unref(puzzleStore).showJustification
          }, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('general.seeReferences')), 1),
            _hoisted_14
          ], 8, _hoisted_12)
        ]),
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('puzzle.reference')), 1),
        _createVNode(ReferencesModal, {
          ref_key: "referencesModal",
          ref: referencesModal,
          references: Object.values(_unref(puzzleReferences))
        }, null, 8, ["references"]),
        _createVNode(PuzzleModalVideoPlayer, {
          ref_key: "puzzleModalVideoPlayer",
          ref: puzzleModalVideoPlayer,
          "data-video-id": _unref(puzzleStore).currentVideoId
        }, null, 8, ["data-video-id"])
      ])
    ]),
    _: 1
  }))
}
}

})